export const drankEnDrugs = [
  "Mojito",
  "Margarita",
  "Piña Colada",
  "Daiquiri",
  "Old Fashioned",
  "Negroni",
  "Caipirinha",
  "Cosmopolitan",
  "Martini",
  "Whiskey Sour",
  "Wodka",
  "Rum",
  "Gin",
  "Tequila",
  "Whiskey",
  "Bier",
  "Cognac",
  "Jenever",
  "Absint",
  "Champagne",
  "MDMA",
  "Cocaïne",
  "LSD",
  "Heroïne",
  "Ketamine",
  "Amfetamine",
  "GHB",
  "Truffels",
  "Xanax",
  "Wiet",
  "Long Island Iced Tea",
  "Mai Tai",
  "Sex on the Beach",
  "Manhattan",
  "Bloody Mary",
  "Aperol Spritz",
  "Blue Lagoon",
  "Zombie",
  "White Russian",
  "Black Russian",
  "Sambuca",
  "Ouzo",
  "Baileys",
  "Grand Marnier",
  "Campari",
  "Vermouth",
  "Sake",
  "Pisco",
  "Brandy",
  "Port",
  "Crack",
  "Speed",
  "Meth",
  "Opium",
  "Psilocybine",
  "DMT",
  "Salvia",
  "2C-B",
  "Ritalin",
  "Morphine",
  "Tom Collins",
  "Sidecar",
  "French 75",
  "Gin Fizz",
  "Sazerac",
  "Cuba Libre",
  "Dark 'n' Stormy",
  "Americano",
  "Vesper",
  "Bellini",
  "Sherry",
  "Grappa",
  "Limoncello",
  "Kahlúa",
  "Frangelico",
  "Chartreuse",
  "Bourbon",
  "Scotch",
  "Armagnac",
  "Mezcal",
  "Nitrous Oxide",
  "Mescaline",
  "PCP",
  "Krokodil",
  "Methadon",
  "Benzodiazepines",
  "Fentanyl",
  "Paddo's",
  "Ayahuasca",
  "DXM",
  "Irish Coffee",
  "Espresso Martini",
  "Gin Tonic",
  "Rum Punch",
  "Planter's Punch",
  "Paloma",
  "Mint Julep",
  "Hurricane",
  "Painkiller",
  "Golden Dream",
];
